import type { SxProps, Theme } from '@mui/material';

/**
 * Scrollbar that is invisible until the user hovers the container.
 * Works across Webkit (Chrome/Safari/Edge) and Firefox.
 * Uses transparent thumb + track so no layout shift occurs.
 */
export const hoverScrollbar: SxProps<Theme> = {
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&::-webkit-scrollbar': { width: 6 },
    '&::-webkit-scrollbar-thumb': { background: 'transparent', borderRadius: 3 },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&:hover': {
        scrollbarColor: 'rgba(128,128,128,0.4) transparent',
    },
    '&:hover::-webkit-scrollbar-thumb': {
        background: 'rgba(128,128,128,0.4)',
    },
};
